import { markRaw } from 'vue'

import WorkflowAppsSidebarTab from '@/components/sidebar/tabs/WorkflowAppsSidebarTab.vue'
import type { SidebarTabExtension } from '@/types/extensionTypes'

export const useWorkflowAppsSidebarTab = (): SidebarTabExtension => {
  return {
    id: 'workflow-apps',
    icon: 'pi pi-mobile',
    title: 'g.workflowApps',
    tooltip: 'g.workflowApps',
    label: 'g.workflowApps',
    component: markRaw(WorkflowAppsSidebarTab),
    type: 'vue'
  }
}
